<div class="flex min-h-screen overflow-x-hidden mb-0">
  <div class="w-full md:w-1/2 flex flex-col justify-center items-center bg-white dark:bg-[#27272A]">
    <div class="w-full py-6 max-w-sm md:px-0 px-4">
      <app-auth-navbar></app-auth-navbar>
      <app-auth-logo></app-auth-logo>
      <router-outlet></router-outlet>
      <app-auth-logo class="block transform -scale-y-100"></app-auth-logo>
    </div>
  </div>

  <div class="hidden md:block md:w-1/2 min-h-screen">
    <app-auth-sidebar ></app-auth-sidebar>
  </div>

</div>
